export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-loop-594282d4fb177402064fe27fffecf05e.svg";